import getLuxPlusCardExpiresBeforeRenewal from 'luxPlus/lib/getLuxPlusCardExpiresBeforeRenewal'

export type LuxPlusInvalidCardReason = 'expired' | 'invalid'

interface LuxPlusCardExpiry {
  expMonth?: number
  expYear?: number
}

/**
 * Why a flagged LP+ renewal card can't be used, for display only: `isInvalid` still decides whether it is flagged.
 * A card whose expiry month has ended is 'expired', anything else Stripe flagged is 'invalid'.
 */
function getLuxPlusInvalidCardReason(card: LuxPlusCardExpiry, now: Date = new Date()): LuxPlusInvalidCardReason {
  return getLuxPlusCardExpiresBeforeRenewal(card, now) ? 'expired' : 'invalid'
}

export default getLuxPlusInvalidCardReason
